(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         * 
         */
        .controller('viewAccessTokenModal',
            ["$uibModalInstance", 'availablePermissions', 'availableTemplates', 'accessToken',
                function ($uibModalInstance, availablePermissions, availableTemplates, accessToken) {

                    var vm = this;

                    vm.availableTemplates = availableTemplates;
                    vm.availablePermissions = availablePermissions;
                    vm.accessToken = accessToken;


                    vm.newAccessToken = {};
                    vm.permissions = {};
                    vm.newPermissions = {};

                    vm.getUsableName = function (name) {
                        return name.split(' ').join('_');
                    };

                    vm.availablePermissionsCol = [];

                    /**
                     * 
                     */
                    vm.separatePermissions = function () {
                        var col = 0;
                        angular.forEach(vm.availablePermissions, function (val) {

                            if (!vm.availablePermissionsCol[col]) {
                                vm.availablePermissionsCol.push([]);
                            }

                            var groupInfo = vm.newAccessToken[vm.getUsableName(val.group)]

                            if (groupInfo.selected != 0) {
                                vm.availablePermissionsCol[col].push(val);
                                col = (col + 1) % 2;
                            }

                        });
                    };

                    /**
                     * 
                     */
                    vm.preparePermissionsStructure = function () {
                        var templateCheck = [];
                        for (var a in vm.availableTemplates) {
                            templateCheck.push([]);
                        }
                        angular.forEach(vm.availablePermissions, function (groupPermissions) {
                            vm.permissions[vm.getUsableName(groupPermissions.group)] = {};
                            angular.forEach(groupPermissions.permissions, function (singlePermission) {
                                vm.permissions[vm.getUsableName(groupPermissions.group)][singlePermission.permission] = false;
                                for (var i in vm.availableTemplates) {
                                    var template = vm.availableTemplates[i];
                                    for (var j in template.permissions) {
                                        if (singlePermission.permission == template.permissions[j]) {
                                            if (templateCheck[i].indexOf(singlePermission.permission) == -1) {
                                                templateCheck[i].push(singlePermission.permission);
                                            }
                                        }
                                    }
                                }
                            });
                        });
                        for (var a in vm.availableTemplates) {
                            if (vm.availableTemplates[a].permissions.length == templateCheck[a].length) {
                                vm.availableTemplates[a].visible = true;
                            }
                        }
                        vm.newPermissions = angular.copy(vm.permissions);
                    };

                    function initialise() {
                        vm.preparePermissionsStructure();

                        /**
                         * Viewing an existing token 
                         */
                        if (vm.accessToken && vm.accessToken.id) {

                            Object.keys(vm.permissions).forEach(function (key, index) {
                                var group = vm.permissions[key];
                                var keyCnt = 0;
                                var selectedCnt = 0;
                                Object.keys(group).forEach(function (key, index) {
                                    keyCnt++;
                                    if (vm.accessToken.permissions.indexOf(key) >= 0) {
                                        group[key] = true;
                                        selectedCnt++;
                                    }
                                });
                                vm.newAccessToken[key] = {
                                    children: keyCnt,
                                    selected: selectedCnt
                                };

                            });
                        }

                        vm.separatePermissions();

                    }


                    initialise();







                    vm.close = function () {
                        $uibModalInstance.dismiss();
                    }

                }]);

})(window.angular);
